// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"4151":"8e5428731b034d5e755d","5108":"8e5428731b034d5e755d","9985":"39469f239b37c94ae8f6"}[chunkId] + ".bundle.css";
};